var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpin6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_people",
    "data-name": "vuesax/outline/people",
    transform: "translate(-620 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "people",
    transform: "translate(620 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.43,8.59H4.262a3.98,3.98,0,1,1,.181.013C4.443,8.59,4.443,8.59,4.43,8.59ZM4.3,1.925a2.365,2.365,0,0,0-.09,4.728.626.626,0,0,1,.232,0A2.366,2.366,0,0,0,4.3,1.925Z",
    transform: "translate(18.819 1.628)",
    fill: "#ea8713"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M2.352,8.43A8.529,8.529,0,0,1,.841,8.3.97.97,0,1,1,1.177,6.39a6.3,6.3,0,0,0,4.392-.775A1.772,1.772,0,0,0,6.5,4.207a1.784,1.784,0,0,0-.93-1.4,6.32,6.32,0,0,0-4.43-.762A.959.959,0,0,1,.014,1.262.969.969,0,0,1,.8.138,8.174,8.174,0,0,1,6.641,1.2a3.679,3.679,0,0,1,1.8,3.01,3.7,3.7,0,0,1-1.8,3.023A7.861,7.861,0,0,1,2.352,8.43Z",
    transform: "translate(20.911 11.306)",
    fill: "#ea8713"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M4.185,8.6H4.159a4.295,4.295,0,1,1,.3,0l-.271-.969.09.969Zm.129-1.937a1.253,1.253,0,0,1,.22.013,2.4,2.4,0,1,0-.336,0A.255.255,0,0,1,4.314,6.665Z",
    transform: "translate(3.526 1.615)",
    fill: "#ea8713"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M6.084,8.43A7.86,7.86,0,0,1,1.8,7.229,3.7,3.7,0,0,1,0,4.207,3.7,3.7,0,0,1,1.8,1.2,8.174,8.174,0,0,1,7.634.138a.969.969,0,0,1,.788,1.124A.959.959,0,0,1,7.3,2.05a6.333,6.333,0,0,0-4.43.762,1.753,1.753,0,0,0-.93,1.4,1.8,1.8,0,0,0,.93,1.408,6.3,6.3,0,0,0,4.392.775A.97.97,0,1,1,7.6,8.3,8.529,8.529,0,0,1,6.084,8.43Z",
    transform: "translate(1.615 11.306)",
    fill: "#ea8713"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M4.43,8.59H4.262a3.98,3.98,0,1,1,.181.013C4.443,8.59,4.443,8.59,4.43,8.59ZM4.3,1.925a2.365,2.365,0,0,0-.09,4.728.626.626,0,0,1,.232,0A2.366,2.366,0,0,0,4.3,1.925Z",
    transform: "translate(11.069 11.276)",
    fill: "#ea8713"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M6.1,8.448A7.746,7.746,0,0,1,1.8,7.233,3.679,3.679,0,0,1,0,4.224,3.686,3.686,0,0,1,1.8,1.2a8.3,8.3,0,0,1,8.6,0,3.679,3.679,0,0,1,1.8,3.01,3.686,3.686,0,0,1-1.8,3.023A7.853,7.853,0,0,1,6.1,8.448ZM2.868,2.829a1.772,1.772,0,0,0-.93,1.408,1.784,1.784,0,0,0,.93,1.4,6.331,6.331,0,0,0,6.445,0,1.772,1.772,0,0,0,.93-1.408,1.784,1.784,0,0,0-.93-1.4A6.361,6.361,0,0,0,2.868,2.829Z",
    transform: "translate(9.403 20.951)",
    fill: "#ea8713"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector-7",
    "data-name": "Vector",
    fill: "none",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H31V31H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.000001907348633 1.000001907348633 L 1.000001907348633 30.00000381469727 L 30.00000381469727 30.00000381469727 L 30.00000381469727 1.000001907348633 L 1.000001907348633 1.000001907348633 M 1.9073486328125e-06 1.9073486328125e-06 L 31.00000381469727 1.9073486328125e-06 L 31.00000381469727 31.00000381469727 L 1.9073486328125e-06 31.00000381469727 L 1.9073486328125e-06 1.9073486328125e-06 Z",
    stroke: "none",
    fill: "#707070"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpin6);
export default __webpack_public_path__ + "static/media/spin6.651f084804b0f0b610d60a7430cc5045.svg";
export { ForwardRef as ReactComponent };